import TariffAiSettings from './TariffAiSettings';

export default TariffAiSettings;
